module.exports = {
    crowdSourcedDelivery: {
        crowdSourcedLimitLabel: 'Max. 40 item limit',
        crowdSourcedDeliveryLabel: 'Partner Delivery Driver',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/crowd-sourced-delivery.js